import { useState, useRef, useEffect } from 'react'
export function useGlobalDragAndDrop() {
  const [isGlobalDragging, setIsGlobalDragging] = useState(false)
  const [isOverTask, setIsOverTask] = useState(false)
  const [droppedFiles, setDroppedFiles] = useState([])
  const [isTaskSelectorOpen, setIsTaskSelectorOpen] = useState(false)
  const dragCounter = useRef(0)
  useEffect(() => {
    const handleDragEnter = (e) => {
      if (e.dataTransfer?.types.includes('Files')) {
        dragCounter.current++
        setIsGlobalDragging(true)
      }
    }
    const handleDragOver = (e) => {
      e.preventDefault()
      if (e.dataTransfer?.types.includes('Files')) {
        e.dataTransfer.dropEffect = 'copy'
        const target = e.target
        setIsOverTask(target instanceof Element && Boolean(target.closest('[data-todo-id]')))
      }
    }
    const handleDragLeave = (e) => {
      if (e.dataTransfer?.types.includes('Files')) {
        dragCounter.current--
        if (dragCounter.current === 0) {
          setIsGlobalDragging(false)
          setIsOverTask(false)
        }
      }
    }
    const handleDrop = (e) => {
      if (e.defaultPrevented) return
      e.preventDefault()
      dragCounter.current = 0
      setIsGlobalDragging(false)
      setIsOverTask(false)
      const files = Array.from(e.dataTransfer?.files || [])
      if (files.length > 0) {
        setDroppedFiles(files)
        setIsTaskSelectorOpen(true)
      }
    }
    window.addEventListener('dragenter', handleDragEnter)
    window.addEventListener('dragover', handleDragOver)
    window.addEventListener('dragleave', handleDragLeave)
    window.addEventListener('drop', handleDrop)
    return () => {
      window.removeEventListener('dragenter', handleDragEnter)
      window.removeEventListener('dragover', handleDragOver)
      window.removeEventListener('dragleave', handleDragLeave)
      window.removeEventListener('drop', handleDrop)
    }
  }, [])
  return {
    isGlobalDragging,
    isOverTask,
    droppedFiles,
    isTaskSelectorOpen,
    setIsTaskSelectorOpen,
    setDroppedFiles,
  }
}
